<!--
* @Name：综合类认定申请审批供应商信息-评审结论选择
* @Author: 王超
* @Date: 2024-12-16
-->
<template>
  <div class="approval-container">
    <van-dialog
      :value="detailsVisible"
      title="详细信息"
      show-cancel-button
      cancel-button-text="取消"
      cancel-button-color="#1989fa"
      confirm-button-text="确定"
      confirm-button-color="#1989fa"
      @cancel="close"
      :beforeClose="beforeClose"
    >
      <div>
        <hi-cell title="供应商：" :value="mainModel.suppName"></hi-cell>
        <hi-cell title="品类：" :value="mainModel.catgName"></hi-cell>
        <van-field
          class="text-font-normal"
          v-model="dispConclusion"
          is-link
          readonly
          label="引入结论:"
          placeholder="请选择引入结论"
          @click="showPicker = true"
          required
        />
        <van-popup v-model="showPicker" round position="bottom" get-container="body">
          <van-picker
            title="请选择引入结论"
            class="text-font-normal"
            show-toolbar
            :columns="nodeArray"
            value-key="name"
            @cancel="showPicker = false"
            @confirm="changeConfirm"
          />
        </van-popup>
        <van-field
          class="text-font-normal"
          label="结论说明:"
          v-model="mainModel.conclusionDesc"
          placeholder="请输入结论说明"
          show-word-limit
          maxlength="200"
          :autosize="{ minHeight: 100, maxHeight: 100 }"
          type="textarea"
        />
      </div>
    </van-dialog>
  </div>
</template>

<script>
import { Dialog } from 'vant'
import { saveReviewResult } from '@/api/qualifyApply'
export default {
  name: 'supplierReview',
  data() {
    return {
      // 评审结论
      nodeArray: [
        {
          name: '同意',
          code: '1'
        },
        {
          name: '不同意',
          code: '0'
        }
      ],
      // 是否显示结论弹框
      showPicker: false,
      // 评审结论
      dispConclusion: ''
    }
  },
  props: {
    // 弹框是否展示
    detailsVisible: {
      type: Boolean
    },
    // 供应商信息数据
    mainModel: {
      type: Object,
      default: () => ({})
    }
  },
  methods: {
    close() {
      this.$emit('close-details-dialog')
    },
    // 选择结论数据回调
    changeConfirm(val) {
      this.dispConclusion = val.name
      this.$set(this.mainModel, 'conclusion', val.code)
      this.showPicker = false
    },
    // 确认后上报数据
    async beforeClose(action, done) {
      if (action === 'confirm') {
        if (this.dispConclusion === '') {
          await Dialog({ message: '请选择引入结论！' })
          done(false)
        } else {
          const param = {
            conclusion: this.mainModel.conclusion,
            conclusionDesc: this.mainModel.conclusionDesc,
            itemId: this.mainModel.id,
            reviewerCode: this.$store.getters.username
          }
          const result = await saveReviewResult(param)
          if (result.success) {
            this.$emit('review-success')
            this.close()
          } else {
            await Dialog({ message: '评审失败，请重试！' })
          }
        }
      } else {
        done()
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.details-container {
  height: 250px;
  box-sizing: border-box;
  padding: 0 20px;
}
</style>
